import { useEffect, useState } from 'react'
import { Outlet, Link } from "react-router-dom";
import './navigation.css'

const Navigation = ({ }) => {

    const [showDropdown, setShowDropdown] = useState(false)
    const [dropdownClass, setDropdownClass] = useState('hidden')

    function toggleDropdown() {
        setShowDropdown(!showDropdown)
    }

    const hideDropdown = () => setShowDropdown(false)

    const handleNavOptionClick = (option) => {
        hideDropdown()
    }

    useEffect(() => {
        if (!showDropdown) {
            setDropdownClass('hidden')
        } else {
            setDropdownClass('visible')
        }
    }, [showDropdown])



    return (
        <nav className="navigation">
            <ul className="navigation">
                <li>
                    <Link className="navigation" onClick={handleNavOptionClick} to={`/`}>HOME</Link>
                </li>
                <li style={{ width: 250 }}>
                    <Link className="navigation" onClick={handleNavOptionClick} to={`message_of_peace`}>MESSAGE OF PEACE</Link>
                </li>
                <li style={{ width: 200 }}>
                    <button className="navigation" onClick={toggleDropdown}>TRIBAL INFO</button>
                    <ul class={`navigation dropdown ${dropdownClass}`}>
                        <li>
                            <Link className="navigation dropdown" onClick={handleNavOptionClick} to={`history`}>HISTORY</Link>
                        </li>
                        <li>
                            <Link className="navigation dropdown" onClick={handleNavOptionClick} to={`documents`}>DOCUMENTS</Link>
                        </li>
                        <li>
                            <Link className="navigation dropdown" onClick={handleNavOptionClick} to={`our_ancestors`}>OUR ANCESTORS</Link>
                        </li>
                        <li>
                            <Link className="navigation dropdown" onClick={handleNavOptionClick} to={`contacts`}>CONTACTS</Link>
                        </li>
                    </ul>
                </li>
                <li>
                    <Link className="navigation" onClick={handleNavOptionClick} to={`news`}>NEWS</Link>
                </li>
                <li>
                    <a className="navigation" target="_blank" rel="noopener noreferrer" href="#">DONATE</a>
                </li>
            </ul>
        </nav>
    )
}

export default Navigation;